/**
 * 将特殊字符进行转义
 * @param keys 关键字
 * @returns
 */
export function escapeSpecialCharacters(keys: string) {
  const escapedQuery = keys.replace(/([+\-!():{}\[\]^"~*?\\])/g, '\\$1')
  return escapedQuery
}
